'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refineTimePeriod = exports.getStartDate = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _dateFns = require('date-fns');

var dateFns = _interopRequireWildcard(_dateFns);

var _date = require('../../rules/src/date');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var computeDisplayFreq = function computeDisplayFreq(start, duration) {
  var startMinute = dateFns.startOfMinute(start);
  var startHour = dateFns.startOfHour(start);
  var startDay = dateFns.startOfDay(start);
  if (!dateFns.isEqual(start, startMinute) || duration === 'S') {
    return 'S';
  } else if (!dateFns.isEqual(start, startHour) || !dateFns.isEqual(start, startDay) || duration === 'H' || duration === 'm') {
    return 'm';
  } else if (!dateFns.isFirstDayOfMonth(start) || duration === 'D') {
    return 'D';
  } else if (dateFns.getMonth(start) !== 0 || duration === 'M') {
    return 'M';
  }
  return 'Y';
};

var getAdder = function getAdder(duration) {
  if (duration === 'S') return dateFns.addSeconds;
  if (duration === 'm') return dateFns.addMinutes;
  if (duration === 'H') return dateFns.addHours;
  if (duration === 'D') return dateFns.addDays;
  if (duration === 'M') return dateFns.addMonths;
  return dateFns.addYears;
};

var getFormat = function getFormat(freqDisplay) {
  if (freqDisplay === 'Y') return 'YYYY';
  if (freqDisplay === 'D') return 'YYYY-MM-DD';
  if (freqDisplay === 'H' || freqDisplay === 'm') {
    return 'HH:mm';
  }
  if (freqDisplay === 'S') {
    return 'HH:mm:ss';
  }
  return 'YYYY-MMM';
};

var getEndDate = function getEndDate(start, mult, duration) {
  var adder = getAdder(duration);
  var endDate = adder(start, Number(mult));
  return dateFns.subSeconds(endDate, 1);
};

var computeName = function computeName(start, end, freqDisplay, locale, format) {
  var opts = { locale: (0, _date.getLocale)(locale) };
  var isSameDay = dateFns.isSameDay(start, end);
  var isSameYear = dateFns.isSameYear(start, end);
  if (freqDisplay === 'H' || freqDisplay === 'm' || freqDisplay === 'S') {
    var dayFormat = getFormat('D');
    if (isSameDay) return dateFns.format(start, dayFormat, opts) + ' ' + dateFns.format(start, format, opts) + ' - ' + dateFns.format(end, format, opts);
    return dateFns.format(start, dayFormat + ' ' + format, opts) + ' - ' + dateFns.format(end, dayFormat + ' ' + format, opts);
  }
  if (freqDisplay !== 'M') {
    return dateFns.format(start, format, opts) + ' - ' + dateFns.format(end, format, opts);
  }

  if (isSameYear && !R.includes('-', format)) {
    var yearFormatMatch = R.match(/([Y]+)/, format);
    var monthFormatMatch = R.match(/([M]+|Mo)/, format);
    var yearFormat = R.length(yearFormatMatch) >= 2 ? R.nth(1, yearFormatMatch) : null;
    var monthFormat = R.length(monthFormatMatch) >= 2 ? R.nth(1, monthFormatMatch) : null;
    var formattedYear = yearFormat ? dateFns.format(start, yearFormat, opts) : null;
    var formattedMonths = monthFormat ? dateFns.format(start, monthFormat, opts) + ' - ' + dateFns.format(end, monthFormat, opts) : null;
    if (monthFormat) {
      return R.pipe(function (format) {
        return yearFormat ? R.replace(yearFormat, formattedYear, format) : format;
      }, R.replace(monthFormat, formattedMonths))(format);
    }
  }
  return dateFns.format(start, format, opts) + ' - ' + dateFns.format(end, format, opts);
};

var getStartDate = exports.getStartDate = function getStartDate(start) {
  if (!R.includes('T', start) && !R.endsWith('Z', start)) {
    return (0, _date.dateWithoutTZ)(new Date(start));
  }
  return new Date(start);
};

var dateWithTZ = function dateWithTZ(date) {
  return dateFns.addMinutes(date, -date.getTimezoneOffset());
};

var refineTimePeriod = exports.refineTimePeriod = function refineTimePeriod(timePeriod, _ref) {
  var locale = _ref.locale,
      _ref$monthlyFormat = _ref.monthlyFormat,
      monthlyFormat = _ref$monthlyFormat === undefined ? 'YYYY-MMM' : _ref$monthlyFormat;
  var id = timePeriod.id;

  var split = R.split('/', id);
  if (R.length(split) !== 2) {
    var _start = getStartDate(R.prop('start', timePeriod));
    var end = getStartDate(R.prop('end', timePeriod));
    return (0, _extends3.default)({}, timePeriod, { start: dateWithTZ(_start).toISOString(), end: dateWithTZ(end).toISOString() });
  }

  var _split = (0, _slicedToArray3.default)(split, 2),
      start = _split[0],
      range = _split[1];

  var startDate = getStartDate(start);
  var match = R.match(/^P(T?)(\d+)([YMDHS])$/, range);
  if (R.isEmpty(match) || !dateFns.isValid(startDate)) {
    return timePeriod;
  }

  var _R$tail = R.tail(match),
      _R$tail2 = (0, _slicedToArray3.default)(_R$tail, 3),
      timeIndicator = _R$tail2[0],
      mult = _R$tail2[1],
      _duration = _R$tail2[2];

  var duration = !R.isEmpty(timeIndicator) && _duration === 'M' ? 'm' : _duration;
  var endDate = getEndDate(startDate, mult, duration);
  var freqDisplay = computeDisplayFreq(start, duration);
  var format = freqDisplay === 'M' ? monthlyFormat : getFormat(freqDisplay);
  var name = computeName(startDate, endDate, freqDisplay, locale, format);

  return (0, _extends3.default)({}, timePeriod, {
    id: id,
    name: name,
    start: dateWithTZ(startDate).toISOString(),
    end: dateWithTZ(endDate).toISOString()
  });
};